<div page-content [fullWidth]="true">
  <div actions class="uk-section-primary uk-preserve-color">
    <sidebar-mobile-toggle class="uk-hidden@m uk-display-block uk-padding-small"></sidebar-mobile-toggle>
  </div>
  <div inner>
    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent>
      <div class="uk-container">
        <div class="uk-flex uk-flex-between uk-flex-middle uk-visible@m">
          <!--          <h4>Citizen Science</h4>-->
          <div class="uk-flex uk-flex-middle uk-margin-bottom">
            <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"
              class="flag-image" width="42" height="42" alt="rounded flag image">
            <div class="uk-margin-small-left">
              <h4 class="uk-margin-remove-bottom">{{ countryName }} - Citizen Science for {{ year }}</h4>
            </div>
          </div>
          <div (click)="exportToPDF([exportContent, exportContent1], 'Open Data')"
            class="uk-flex uk-flex-center" style="cursor: pointer">
            <div class="uk-flex uk-flex-middle uk-text-primary" style="background-color: #DAEEF3; border-radius: 30px; padding: 5px 7px">
              <span class="" style="background-color: #fff; border-radius: 50px; border: 1px solid #008691; padding: 4px 10px">
                Export report
              </span>
              @if (exportActive) {
                <span class="uk-margin-small-left"
                data-uk-spinner="ratio: 0.7"></span>
              } @else {
                <span class="material-symbols-outlined filled uk-margin-small-left uk-text-primary">download</span>
              }
            </div>
          </div>
        </div>
        <div class="uk-hidden@m">
          <!--          <h4>Citizen Science</h4>-->
          <div class="uk-flex uk-flex-middle uk-margin-bottom">
            <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"
              class="flag-image" width="42" height="42" alt="rounded flag image">
            <div class="uk-margin-small-left">
              <h4 class="uk-margin-remove-bottom">{{ countryName }} - Citizen Science for {{ year }}</h4>
            </div>
          </div>
          <div class="uk-flex uk-flex-right"
            (click)="exportToPDF([exportContent, exportContent1], 'Open Data')" style="cursor: pointer">
            <div class="uk-flex uk-flex-middle uk-text-primary"
              style="background-color: #DAEEF3; border-radius: 30px; padding: 5px 7px">
              <span class=""
                style="background-color: #fff; border-radius: 50px; border: 1px solid #008691; padding: 4px 10px">
                Export report
              </span>
              @if (exportActive) {
                <span class="uk-margin-small-left"
                data-uk-spinner="ratio: 0.7"></span>
              } @else {
                <span class="material-symbols-outlined filled uk-margin-small-left uk-text-primary">download</span>
              }
            </div>
          </div>
        </div>
        <!--        <div class="uk-flex uk-flex-middle uk-margin-bottom">-->
        <!--          <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"-->
        <!--            class="flag-image" width="42" height="42" alt="rounded flag image">-->
        <!--          <div class="uk-margin-small-left">-->
        <!--            <h3 class="uk-margin-remove-bottom">{{ countryName }}</h3>-->
      <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="uk-flex uk-flex-between uk-flex-middle">-->
    <!--          <h4>Citizen Science</h4>-->
  <!--        </div>-->

  <div class="section-hidden-notice-band">
    <app-section-hidden-notice sectionName="Citizen Science"></app-section-hidden-notice>
  </div>

  <p class="uk-margin-medium-bottom">Citizen Science involves public participation and collaboration in scientific research to increase the
    accessibility, transparency, and democratization of knowledge creation. The aim is to foster innovative
    discoveries by combining the efforts of scientists with contributions from citizens. This page provides an
    overview of Citizen Science in Europe, featuring key data from the Survey on National Contributions to EOSC
    and Open Science. The data highlights progress and engagement in Citizen Science, supporting broader Open
  Science goals.</p>
  <!--        <pre>{{ surveyAnswers | json }}</pre>-->
  <div class="uk-flex uk-flex-between uk-flex-middle">
    <h5>General Overview of Citizen Science in {{ countryName }} for {{ year }}</h5>
  </div>

  <div class="uk-grid-small uk-grid" data-uk-grid>

    @if (hasAnyLeftCardVisible()) {
      <div class="uk-width-1-1 uk-width-3-5@m uk-animation-fade">
        <div class="uk-card uk-card-default uk-card-body">
          <div
            class="uk-child-width-1-1@s uk-child-width-1-2@m uk-grid-small uk-grid-match uk-flex uk-flex-center"
            data-uk-grid>
<!--            @if (citizenScienceProjects[1] !== null && citizenScienceProjects[1] !== undefined) {-->
<!--              <app-info-card-->
<!--                [titleHtml]="`Number of new Citizen Science projects in <span class='uk-text-bold'>${countryName}</span>`"-->
<!--                [value]="citizenScienceProjects[1]"-->
<!--                [unit]="''"-->
<!--                [diff]="citizenSciencePercentageDiff"-->
<!--                colorClass="eosc-sb visualisation-card">-->
<!--              </app-info-card>-->
<!--            }-->
            <app-card-config indicatorId="47" colorClass="eosc-sb visualisation-card">
            @if (financialInvestmentInCS[1] !== null && financialInvestmentInCS[1] !== undefined) {
              <app-info-card
                [titleHtml]="`Total amount of <span class='uk-text-bold'>financial investments</span> in Citizen Science`"
                [value]="financialInvestmentInCS[1]"
                [unit]="'mil Euro'"
                [diff]="financialInvestmentInCsPercentageDiff"
                colorClass="eosc-sb visualisation-card">
              </app-info-card>
            }
            </app-card-config>
          </div>
        </div>
      </div>
    }

  <!-- Right Card (2/5) -->
  <app-card-config indicatorId="48" class="uk-width-1-1 uk-width-2-5@m uk-animation-fade">
  <div> <!-- uk-width-1-1 mobile, 2/5@m desktop-->
    <div class="uk-card uk-card-default uk-card-body eosc-sb visualisation-card">
      <div class="uk-margin-top">
        <h5 class="uk-flex uk-flex-between uk-margin-remove">
          National Policy on Citizen Science
                  <span class="material-symbols-outlined" [ngClass]="{
                    'up-arrow-color': hasNationalPolicyCS === 'Yes',
                    'down-arrow-color': hasNationalPolicyCS === 'No',
                    'unanswered-color': hasNationalPolicyCS=== null || hasNationalPolicyCS === undefined
                  }">
            {{
            hasNationalPolicyCS === 'Yes' ? 'check' :
            hasNationalPolicyCS === 'No' ? 'close' :
            'question_mark'
            }}
          </span>
        </h5>
        @if (policyMandatoryCS === 'Yes') {
          <p class="uk-text-primary uk-text-bolder uk-margin-remove-top">
          Mandatory policy</p>
        }
        @if (nationalPolicyClarificationCS !== null) {
          <read-more-text [maxHeight]="68"
          [text]="nationalPolicyClarificationCS"></read-more-text>
        }
      </div>
      <div class="uk-margin-top">
        <h5 class="uk-flex uk-flex-between">
          Financial Strategy on Citizen Science
                  <span class="material-symbols-outlined" [ngClass]="{
                    'up-arrow-color': hasFinancialStrategyCS === 'Yes',
                    'down-arrow-color': hasFinancialStrategyCS === 'No',
                    'unanswered-color': hasFinancialStrategyCS=== null || hasFinancialStrategyCS === undefined
                  }">
            {{
            hasFinancialStrategyCS === 'Yes' ? 'check' :
            hasFinancialStrategyCS === 'No' ? 'close' :
            'question_mark'
            }}
          </span>
        </h5>
        @if (financialStrategyClarificationCS) {
          <read-more-text [maxHeight]="68"
          [text]="financialStrategyClarificationCS"></read-more-text>
        }
      </div>
      <div class="uk-margin-top">
        <h5 class="uk-flex uk-flex-between">
          Monitoring on Citizen Science
                  <span class="material-symbols-outlined" [ngClass]="{
                    'up-arrow-color': hasMonitoringCS === 'Yes',
                    'down-arrow-color': hasMonitoringCS === 'No',
                    'unanswered-color': hasMonitoringCS=== null || hasMonitoringCS === undefined
                  }">
            {{
            hasMonitoringCS === 'Yes' ? 'check' :
            hasMonitoringCS === 'No' ? 'close' :
            'question_mark'
            }}
          </span>
        </h5>
        @if (monitoringClarificationCS) {
          <read-more-text [maxHeight]="68"
          [text]="monitoringClarificationCS"></read-more-text>
        }
      </div>
    </div>
  </div>
  </app-card-config>
</div>
<div class="uk-width-1-1 uk-margin-top uk-flex uk-flex-center">
  <div>
    <p><span class="uk-text-bold">Data source:</span>
    Survey on National Contributions to EOSC and Open Science {{year}} -
    showing data for {{ year }}, except financial contributions, which reflect the previous year ({{+year-1}});
    OpenAIRE Graph data for {{ year }} (updated on {{ lastUpdateDate }}).
  </p>
</div>
</div>
</div>
</div>
<div #exportContent1>

  @if (hasSurveyCitizenScienceData()) {
    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small">
      <div class="uk-container">
        <app-card-config indicatorId="49">
        <div class="uk-animation-fade">
          <div class="uk-card uk-card-body uk-card-default eosc-sb visualisation-card">
            <h6 class="uk-margin-bottom">Learn more about Citizen Science Landscape in {{ countryName }}</h6>
            <div class="uk-text-meta">This information has been compiled by the National Open Access Desks on {{ countrySurveyAnswerLastUpdate | date: 'yyyy-MM-dd'}}</div>
            <div class="uk-margin-medium-top">
              <read-more [maxHeight]="300">
                <div>
                  @if (surveyAnswers[1]?.['Practices']?.['Question99']?.['Question99-0'] === 'Yes') {
                    @if (surveyAnswers[1]?.['Practices']?.['Question99']?.['Question99-1-0']?.length) {
                      @for (element of surveyAnswers[1]['Practices']['Question99']['Question99-1-0']; track element) {
                        <div class="uk-margin-small-bottom"> @if (element['Question99-1']?.trim() !== '') {
                          <p class="uk-margin-remove-top" [innerHTML]="element['Question99-1']"></p>
                        }
                          @if (element?.['Question99-2-1']?.length) {
                            <ul class="uk-margin-remove-top">
                              @for (subElement of element['Question99-2-1']; track subElement) {
                                <li>
                                  @if (subElement?.trim() !== '') {
                                    <p class="uk-margin-remove" [innerHTML]="subElement"></p>
                                  }
                                </li>
                              }
                            </ul>
                          }
                        </div>
                      }
                    }
                  } @else {
                    <p class="uk-margin-remove-top">There are no use cases</p>
                  }
                  @if (surveyAnswers[1]?.['Practices']?.['Question99']?.['Question99-3']) {
                    <p class="uk-margin-remove-top"
                       [innerHTML]="surveyAnswers[1]['Practices']['Question99']['Question99-3']">
                    </p>
                  }
                </div>
              </read-more>
            </div>
          </div>
        </div>
        </app-card-config>
      </div>
    </div>
  }

</div>
</div>
</div>
